import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, Teleport as _Teleport, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-59678b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "chip-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "status"
}
const _hoisted_5 = { class: "line-route-name" }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "departure" }
const _hoisted_8 = { class: "label-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "승차", -1 /* HOISTED */))
const _hoisted_10 = { class: "bus-stop--name" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"bus-stop-line\" data-v-59678b4c><div class=\"dot\" data-v-59678b4c></div><div class=\"dot\" data-v-59678b4c></div><div class=\"dot\" data-v-59678b4c></div><div class=\"dot\" data-v-59678b4c></div></div>", 1)
const _hoisted_12 = { class: "arrival" }
const _hoisted_13 = { class: "label-wrapper" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "하차", -1 /* HOISTED */))
const _hoisted_15 = { class: "bus-stop--name" }
const _hoisted_16 = { class: "line-info-wrapper" }
const _hoisted_17 = { class: "line-info-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "운행요일", -1 /* HOISTED */))
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { class: "line-info-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "차량정보", -1 /* HOISTED */))
const _hoisted_22 = { class: "car-no-content" }
const _hoisted_23 = { class: "bus-order" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_25 = { class: "footer" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "예약하기", -1 /* HOISTED */))
const _hoisted_29 = {
  key: 2,
  class: "monthly-book"
}
const _hoisted_30 = { class: "tooltip-wrapper" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("월예약 진행 중 일부날짜가"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("만석이 될 수 있습니다.")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["LineTypeChip"], {
            lineTypeCode: $props.favoriteLine.lineTypeCode,
            lineTypeName: $props.favoriteLine.lineTypeName
          }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
          ($setup.isBoarding)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "탑승중"))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          class: "route-name-wrapper",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickLineInfo', $props.favoriteLine)))
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.useGetLineRouteName(
              $props.favoriteLine.lineTypeCode,
              $props.favoriteLine.routeName,
              $props.favoriteLine.lineNum
            )), 1 /* TEXT */),
          ($setup.isBookable)
            ? (_openBlock(), _createBlock($setup["BookChip"], { key: 0 }))
            : _createCommentVNode("v-if", true),
          _createVNode($setup["InlineSvg"], {
            class: "img-arrow",
            src: require('@/assets/icons/chevron-right.svg'),
            alt: "노선 정보 보기"
          }, null, 8 /* PROPS */, ["src"])
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["departure-header", {
            parking: !!$props.favoriteLine.getOnBusStop?.shouldShowBusStopLayout,
          }])
          }, [
            _createElementVNode("div", {
              class: "departure-label",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emitOnClickBusStopLocation($props.favoriteLine.getOnBusStop)))
            }, [
              (!!$props.favoriteLine.getOnBusStop?.shouldShowBusStopLayout)
                ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                    key: 0,
                    class: "img-parking",
                    src: require('@/assets/icons/parking.svg'),
                    alt: "정류장배치도"
                  }, null, 8 /* PROPS */, ["src"]))
                : (_openBlock(), _createBlock($setup["InlineSvg"], {
                    key: 1,
                    class: "img-bus-stop",
                    src: require('@/assets/icons/place-filled.svg'),
                    alt: "지도"
                  }, null, 8 /* PROPS */, ["src"])),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", _hoisted_10, _toDisplayString($setup.getOnBusStopName), 1 /* TEXT */)
              ])
            ])
          ], 2 /* CLASS */),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(["arrival-header", {
            parking: !!$props.favoriteLine.getOffBusStop?.shouldShowBusStopLayout,
          }])
          }, [
            _createElementVNode("div", {
              class: "arrival-label",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emitOnClickBusStopLocation($props.favoriteLine.getOffBusStop)))
            }, [
              (!!$props.favoriteLine.getOffBusStop?.shouldShowBusStopLayout)
                ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                    key: 0,
                    class: "img-parking",
                    src: require('@/assets/icons/parking.svg'),
                    alt: "정류장배치도"
                  }, null, 8 /* PROPS */, ["src"]))
                : (_openBlock(), _createBlock($setup["InlineSvg"], {
                    key: 1,
                    class: "img-bus-stop",
                    src: require('@/assets/icons/place-filled.svg'),
                    alt: "지도"
                  }, null, 8 /* PROPS */, ["src"])),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("p", _hoisted_15, _toDisplayString($setup.getOffBusStopName), 1 /* TEXT */)
              ])
            ])
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("p", _hoisted_19, _toDisplayString($setup.driveWeekDayText), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", {
                class: _normalizeClass(["content", { underline: !$setup.isBoarding && $setup.busOrderCount > 1 }]),
                onClick: $setup.toogleShowCarNoTooltipIfNeeded
              }, _toDisplayString($setup.busPlateNumberText), 3 /* TEXT, CLASS */),
              (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
                _createVNode($setup["Tooltip"], {
                  shouldShowTooltip: $setup.busOrderCount > 1 && $setup.shouldShowCarNoTooltip,
                  targetElement: $setup.carNoTooltipTargetElement,
                  onOnClickCloseTooltip: $setup.closeBusPlateNumbersTooltip
                }, {
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.favoriteLine.buses, (busInfo) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: busInfo.allocUid
                      }, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(busInfo.busOrder), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString(`${busInfo.carNo ?? " - "}${$setup.displayLastSeatCount(
                          busInfo.allocUid
                        )}`), 1 /* TEXT */),
                        _hoisted_24
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["shouldShowTooltip", "targetElement"])
              ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("footer", _hoisted_25, [
        (!$setup.isBookable || $setup.isBoarding)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn report-btn",
              type: "button",
              disabled: !$setup.isBookable && !$setup.isBoarding,
              onClick: $setup.emitOnClickReportBtn
            }, " 신고 ", 8 /* PROPS */, _hoisted_26))
          : _createCommentVNode("v-if", true),
        ($setup.isBookable && !$setup.isBoarding)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn book-btn",
              type: "button",
              disabled: $setup.isBookBlocked || $setup.isBookCountExceeded,
              onClick: $setup.onClickBook
            }, [
              _createElementVNode("span", null, [
                _hoisted_28,
                ($setup.shouldShowRemainBookCount)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" (잔여횟수: " + _toDisplayString($setup.userRemainBookCount) + "회) ", 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ], 8 /* PROPS */, _hoisted_27))
          : _createCommentVNode("v-if", true),
        ($setup.dailyBookInterval && $setup.monthlyBookable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode($setup["CheckboxInput"], {
                class: "check-box-input",
                disabled: $setup.isBookBlocked || $setup.isBookCountExceeded,
                value: $props.favoriteLine.monthlyBookChecked,
                title: $setup.monthlyBookLabel,
                onOnChangedCheck: $setup.emitOnChangedCheck
              }, null, 8 /* PROPS */, ["disabled", "value", "title"]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("img", {
                  class: "img-info",
                  src: _imports_0,
                  alt: "",
                  onClick: $setup.toogleShowMonthlyBookTooltip
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
                  _createVNode($setup["Tooltip"], {
                    shouldShowTooltip: $setup.shouldShowMonthlyBookTooltip,
                    targetElement: $setup.monthlyBookTooltipTargetElement,
                    minWidth: "120px",
                    onOnClickCloseTooltip: $setup.hideTooltipImmediately
                  }, {
                    content: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["shouldShowTooltip", "targetElement"])
                ]))
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowBookDetail,
        onBackHandler: () => $setup.toggleShowBookDetail(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["BookDetail"], {
            turnId: $props.favoriteLine.turnId,
            getOnBusStopId: $props.favoriteLine.getOnBusStop?.id ?? '',
            getOffBusStopId: $props.favoriteLine.getOffBusStop?.id ?? '',
            lineFare: $props.favoriteLine.lineFare,
            bookIntervals: $props.favoriteLine.bookIntervals ?? [],
            onOnClickClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowBookDetail(false)))
          }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "lineFare", "bookIntervals"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowMonthlyBookDetail,
        onBackHandler: () => $setup.toggleShowMonthlyBookDetail(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["MonthlyBookDetailWithDuplicatedSeat"], {
            turnId: $props.favoriteLine.turnId,
            getOnBusStopId: $props.favoriteLine.getOnBusStop?.id ?? '',
            getOffBusStopId: $props.favoriteLine.getOffBusStop?.id ?? '',
            bookIntervals: $props.favoriteLine.bookIntervals ?? [],
            bookableDatesInfos: $setup.bookableDatesInfos,
            lineFare: $props.favoriteLine.lineFare,
            isMonthlyBook: true,
            onOnClickClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowMonthlyBookDetail(false)))
          }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "bookIntervals", "bookableDatesInfos", "lineFare"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ])),
    ($setup.shouldShowMonthlySeatAndPayment)
      ? (_openBlock(), _createBlock($setup["MonthlyBookSeatAndPayment"], {
          key: 0,
          ref: "monthlyBookSeatAndPayment",
          turnId: $props.favoriteLine.turnId,
          getOnBusStopId: $props.favoriteLine.getOnBusStop?.id ?? '',
          getOffBusStopId: $props.favoriteLine.getOffBusStop?.id ?? '',
          lineFare: $props.favoriteLine.lineFare,
          seatsSelectable: !!$setup.monthlyBookInterval?.seatsSelectable,
          currentBookInterval: $setup.BookIntervalCode.MONTH,
          onToggleShowBookDetail: $setup.toggleShowBookDetail
        }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "lineFare", "seatsSelectable", "currentBookInterval"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}